var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12.4316 6C13.0183 6 13.5522 6.06934 14.0322 6.20801C14.5121 6.33601 14.9283 6.53911 15.2803 6.81641C15.6428 7.0937 15.9204 7.44555 16.1123 7.87207C16.3042 8.28803 16.4004 8.7894 16.4004 9.37598C16.4004 10.1653 16.224 10.8052 15.8721 11.2959C15.5308 11.7758 15.0561 12.1276 14.4482 12.3516C13.8402 12.5649 13.1518 12.6719 12.3838 12.6719H11.5195V13.6162H14.6719V15.1035H11.5195V17.4561H9.28027V15.1035H8V13.6162H9.28027V12.6719H8V11.2002H9.28027V6H12.4316ZM11.5195 11.2002H12.4004C12.7736 11.2002 13.0938 11.1358 13.3604 11.0078C13.6268 10.8798 13.8292 10.6825 13.9678 10.416C14.1171 10.1494 14.1924 9.81345 14.1924 9.4082C14.1924 9.01357 14.123 8.69853 13.9844 8.46387C13.8564 8.21853 13.6583 8.04221 13.3916 7.93555C13.1357 7.82902 12.8154 7.77637 12.4316 7.77637H11.5195V11.2002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubInCircle);
export default __webpack_public_path__ + "static/media/rubInCircle.d048aae21ef3e895b8222623fd7b6a6b.svg";
export { ForwardRef as ReactComponent };